// Deterministic layout for the GovCon graph canvas. The data model has no node
// coordinates, so newly-seen nodes are placed on a ring (stable by index) and
// the canvas preserves any position the user drags a node to thereafter. No
// layout dependency — a ring reads cleanly for the small graphs a single
// pursuit involves.
export function ringPosition(count, index) {
    if (count <= 1) return {
        x: 0,
        y: 0
    };
    // Radius grows with node count so labels don't overlap; angle steps evenly.
    const radius = Math.max(200, count * 38);
    const angle = 2 * Math.PI * index / count;
    return {
        x: Math.round(radius * Math.cos(angle)),
        y: Math.round(radius * Math.sin(angle))
    };
}
